import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../../theme/ColorModeIconDropdown';

const Toolbar = styled(Stack)(({ theme }) => ({
  height: 'var(--template-frame-height, 50px)',
  padding: '8px 12px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'none',
}));

export default function AppNavbar({ onToggleDrawer }: { onToggleDrawer: () => void }) {
  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'auto', md: 'none' },
        boxShadow: 0,
        bgcolor: 'background.paper',
        backgroundImage: 'none',
        borderBottom: '1px solid',
        borderColor: 'divider',
        top: 'var(--template-frame-height, 0px)',
      }}
    >
      <Toolbar>
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
          <Typography variant="h6" component="h1" sx={{ color: 'text.primary', fontSize: '1.1rem', fontWeight: 700 }}>
            Project Manager
          </Typography>
        </Stack>
        <Stack direction="row" sx={{ gap: 1 }}>
          <ColorModeIconDropdown />
          <MenuButton aria-label="menu" onClick={onToggleDrawer}>
            <MenuRoundedIcon />
          </MenuButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
